'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  config: {
    id: '',
    theme: 'theme-background-image-dark',
    backgroundUrl: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business.jpg'
  },
  content: {
    panelOne: {
      backgroundUrl: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-bifurcated-personal2.jpg',
      headline: {
        text: '36 characters (2 lines) maximum.'
      },
      paragraph: {
        text: 'paragraph - 140 characters maximum.'
      },
      primaryCta: {
        id: '',
        href: '#',
        text: '18 characters maximum',
        target: '_self'
      },
      hatchText: {
        text: '34 characters maximum per line'
      }
    },
    panelTwo: {
      backgroundUrl: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-bifurcated-business2.jpg',
      headline: {
        text: '36 characters (2 lines) maximum.'
      },
      paragraph: {
        text: 'paragraph - 140 characters maximum.'
      },
      primaryCta: {
        id: '',
        href: '#',
        text: '18 characters maximum',
        target: '_self'
      },
      hatchText: {
        text: '34 characters maximum per line'
      }
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/bifurcated-hero/props/default.js
// module id = 1071
// module chunks = 4